import { useTheme } from "../../../../context/theme";
import { KeyColorRole, Theme } from "../../../../styles/colors/types";

export default function useIconButtonColorStyleProps({
  tone,
  disabled,
  blend
}: {
  tone: KeyColorRole;
  disabled: boolean;
  blend: boolean;
}) {
  const theme = useTheme();

  return blend
    ? blendStyles(tone, disabled, theme)
    : filledStyles(tone, disabled, theme);
}

function filledStyles(tone: KeyColorRole, disabled = false, theme: Theme) {
  const backgroundColor = theme[`${tone}-low-surface`];
  const borderColor = theme[`${tone}-xLow-content`];
  const color = theme[`${tone}-high-content`];

  const hoverStyles = disabled
    ? undefined
    : {
        backgroundColor: theme[`${tone}-medium-surface`],
        borderColor: theme[`${tone}-low-content`]
      };

  const activeStyles = disabled
    ? undefined
    : {
        backgroundColor: theme[`${tone}-high-surface`],
        borderColor: theme[`${tone}-high-surface`],
        color: theme[`contentOn-${tone}-high-surface`]
      };

  return {
    backgroundColor,
    borderColor,
    color,
    hoverStyles,
    activeStyles
  };
}

function blendStyles(tone: KeyColorRole, disabled = false, theme: Theme) {
  const backgroundColor = "transparent";
  const borderColor = "transparent";
  const color = theme[`${tone}-high-content`];

  const hoverStyles = disabled
    ? undefined
    : {
        backgroundColor: theme[`${tone}-low-surface`]
      };

  const activeStyles = disabled
    ? undefined
    : {
        backgroundColor: theme[`${tone}-medium-surface`]
      };

  return {
    backgroundColor,
    borderColor,
    color,
    hoverStyles,
    activeStyles
  };
}
